module.exports = __webpack_public_path__ + "img/8.2269a03f.png";